<template class="mr-3">
  <div class="card">
    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      :title="$t('all.enterInformationBelow')"
      :width="400"
      :footer="false"
    >
      <a-form :form="rejectForm" @submit="rejectPunition">
        <a-form-item :label="$t('punition.raison')">
          <a-textarea
            :placeholder="isKenyan ? $t('punition.rejectReasonDiscipline') : $t('punition.rejectReason')"
            v-decorator="[
              'reason',
              {
                rules: [
                  {
                    required: true,
                    message: this.$t('punition.reasonRequired'),
                  },
                ],
              },
            ]"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>

        <div class="form-actions mt-0">
          <a-button
            style="width: 150px"
            type="primary"
            html-type="submit"
            class="mr-3"
            >{{ $t("action.confirmer") }}</a-button
          >
          <a-button key="back" @click="cancelReject">{{
            $t("action.annuler")
          }}</a-button>
        </div>
      </a-form>
    </a-modal>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      :width="'min(920px, 92vw)'"
      :z-index="1100"
      wrap-class-name="punishment-image-preview-modal"
      @cancel="closeImagePreview"
    >
      <img
        alt=""
        class="punishment-preview-img"
        :src="previewImage"
      />
    </a-modal>
    <a-modal
      v-model="addPunishmentModal"
      @cancel="resetAndCloseAddPunishment"
      :title="$t('all.add') + ' ' + (isKenyan ? $t('punition.studentDiscipline') : $t('punition.punition'))"
      :width="800"
      :footer="false"
      :destroyOnClose="true"
    >
      <a-form :form="punishmentForm" @submit="addPunition">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <a-form-item :label="$t('emploi.classe')">
                <a-select
                  @change="handleChangeClass"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="classRoom in classList"
                    :key="classRoom._id"
                    :value="classRoom._id"
                  >
                    {{ classRoom.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item :label="$t('punition.eleve')">
                <a-select
                  :disabled="studentList.length == 0"
                  :loading="classRoomChangeLoading"
                  :value="selectedStudents"
                  show-search
                  allow-clear
                  mode="multiple"
                  :filter-option="filterOption"
                  @change="selectStudents"
                >
                  <a-select-option
                    v-for="student in studentList"
                    :key="student._id"
                    :value="student._id"
                  >
                    {{ student.firstName }}{{ student.middleName ? " " + student.middleName : "" }} {{ student.lastName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <div class="row" v-if="selectedStudents.length > 0">
            <div class="card col-md-12">
              <div class="card-body container">
                <div class="row">
                  <div class="col-md-12">
                    <a-form-item :label="$t('punition.raison')">
                      <a-input
                        v-decorator="[
                          'reason',
                          {
                            rules: [
                              {
                                required: true,
                                message: this.$t('punition.reasonRequired'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <a-form-item :label="$t('recette.type')">
                      <a-select
                        v-decorator="[
                          'punishmentType',
                          {
                            rules: [
                              {
                                required: true,
                                message: this.isKenyan
                                  ? this.$t('punition.typeRequiredDiscipline')
                                  : this.$t('punition.typeRequired'),
                              },
                            ],
                          },
                        ]"
                        show-search
                        :filter-option="filterOption"
                      >
                        <a-select-option
                          v-for="punishmentType in punishmentTypes"
                          :key="punishmentType._id"
                          :value="punishmentType._id"
                        >
                          {{ punishmentType.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-6">
                    <a-form-item :label="$t('punition.eventTime')">
                      <a-date-picker
                        format="DD/MM/YYYY HH:mm"
                        show-time
                        :placeholder="$t('recette.selectionnerDate')"
                        v-decorator="[
                          'time',
                          {
                            rules: [
                              {
                                required: true,
                                message: this.$t('punition.timeRequired'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <a-form-item :label="$t('emploi.trimestre')">
                      <a-select
                        v-decorator="[
                          'trimester',
                          {
                            initialValue: selectedTrimester,
                            rules: [
                              {
                                required: true,
                                message:
                                  this.$t('emploi.trimestre') +
                                  ' ' +
                                  this.$t('punition.reasonRequired'),
                              },
                            ],
                          },
                        ]"
                      >
                        <a-select-option value="1"
                          >{{ $t("actualite.trimestre1") }}
                        </a-select-option>
                        <a-select-option value="2"
                          >{{ $t("actualite.trimestre2") }}
                        </a-select-option>
                        <a-select-option value="3"
                          >{{ $t("actualite.trimestre3") }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <a-form-item :label="$t('actualite.description')">
                      <quill-editor v-model="punishmentDescription" :options="editorOptions" />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <a-form-item label="Attachments">
                      <a-upload-dragger
                        :file-list="attachmentFiles"
                        :before-upload="beforeUploadAttachment"
                        :disabled="isUploadingFiles"
                        @remove="removeAttachmentFile"
                      >
                        <p class="ant-upload-drag-icon">
                          <a-icon type="inbox" />
                        </p>
                        <p class="ant-upload-text">Upload documents or images</p>
                      </a-upload-dragger>
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <a-form-item label="Audio Files">
                      <a-upload
                        :file-list="audioFiles"
                        :before-upload="beforeUploadAudio"
                        :disabled="isUploadingFiles"
                        @remove="removeAudioFile"
                      >
                        <a-button>
                          <a-icon type="upload" /> Upload Audio
                        </a-button>
                      </a-upload>
                    </a-form-item>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="isUploadingFiles && progress.value > 0 && progress.value < 100"
                >
                  <div class="col-md-12">
                    <a-form-item>
                      <a-progress
                        :stroke-color="{
                          from: '#108ee9',
                          to: '#87d068',
                        }"
                        :percent="progress.value"
                        status="active"
                      />
                    </a-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions mt-0">
          <a-popconfirm
            :title="addPunitionConfirmMessage"
            @confirm="handleConfirmAddPunition"
            :ok-text="$t('action.confirmer')"
            :cancel-text="$t('action.annuler')"
          >
            <a-button
              style="width: 150px"
              type="primary"
              class="mr-3"
              :loading="addPunishmentLoading"
              >{{ $t("action.confirmer") }}</a-button
            >
          </a-popconfirm>
          <a-button key="back" @click="resetAndCloseAddPunishment">{{
            $t("action.annuler")
          }}</a-button>
        </div>
      </a-form>
    </a-modal>
    <a-modal
      v-model="visibleSeenByModal"
      @cancel="closeSeenByModal"
      :title="$t('punition.seenByParents')"
      :width="520"
      :footer="false"
    >
      <div v-if="selectedSeenBy.length === 0" class="text-muted">No parent has viewed this punishment yet.</div>
      <div v-else>
        <div
          v-for="(item, idx) in selectedSeenBy"
          :key="`${item.parent || idx}-${item.seenAt || idx}`"
          class="d-flex justify-content-between border-bottom py-2"
        >
          <span>{{ formatSeenByParent(item) }}</span>
          <span class="text-muted">
            {{ formatSeenByDate(item) }}
          </span>
        </div>
      </div>
    </a-modal>
    <div class="card-body">
      <div>
        <div>
          <!-- Profile MODAL --->
          <a-drawer
            :title="isKenyan ? $t('punition.studentDiscipline') : $t('punition.punition')"
            placement="right"
            :closable="true"
            :visible="visibleProfileData"
            @close="handleCancel"
            :width="600"
          >
            <a-form class="container punishment-profile-drawer-body" style="font-size: 15px">
              <fieldset>
                <legend>{{ $t("punition.eleve") }}:</legend>
                <div class="row">
                  <div class="col-md-3">
                    <strong class="pr-1"> {{ $t("punition.nom") }}: </strong>
                    {{
                      updateData.student ? updateData.student.firstName : null
                    }}
                  </div>
                  <div class="col-md-3" v-if="updateData.student && updateData.student.middleName">
                    <strong class="pr-1"> {{ $t("profil.middleName") }}: </strong>
                    {{
                      updateData.student ? updateData.student.middleName : null
                    }}
                  </div>
                  <div class="col-md-3">
                    <strong class="pr-1"> {{ $t("punition.prenom") }}: </strong>
                    {{
                      updateData.student ? updateData.student.lastName : null
                    }}
                  </div>
                </div>
              </fieldset>
              <fieldset class="mt-3">
                <legend>{{ $t("punition.details") }}:</legend>
                <div class="row">
                  <div class="col-md-12">
                    <strong class="pr-1">
                      {{ isKenyan ? $t("punition.studentDiscipline") : $t("punition.punition") }}: </strong
                    >{{
                      updateData.punishmentType
                        ? updateData.punishmentType.name
                        : null
                    }}
                  </div>
                  <div class="col-md-12">
                    <strong class="pr-1">
                      {{ $t("punition.dateAjout") }}: </strong
                    >{{ moment(updateData.createdAt).format("DD/MM/YYYY HH:mm") }}
                  </div>
                  <div class="col-md-12">
                    <strong class="pr-1">
                      {{ $t("punition.eventTime") }}: </strong
                    >{{ moment(updateData.time).format("DD/MM/YYYY HH:mm") }}
                  </div>
                  <div class="col-md-12">
                    <strong class="pr-1">
                      {{ $t("punition.dateEvalution") }}: </strong
                    >{{
                      moment(updateData.reviewDate).format("DD/MM/YYYY HH:mm")
                    }}
                  </div>
                  <div class="col-md-12" style="margin-top: 6px">
                    <strong class="pr-1">{{ $t("emploi.trimestre") }}: </strong>
                    <span>{{
                      updateData.trimester ? updateData.trimester : "--"
                    }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <strong class="pr-1"> {{ $t("punition.raison") }}: </strong
                    >{{ updateData.reason }}
                  </div>
                  <div class="col-md-12">
                    <strong> {{ $t("punition.description") }}: </strong>
                    <br />
                    <div v-html="updateData.desc"></div>
                  </div>
                  <div class="col-md-12 mt-2">
                    <strong>{{ $t("punition.seenByParents") }}:</strong>
                    <a-alert
                      v-if="updateData.validated !== 'validated'"
                      class="mt-2"
                      type="warning"
                      show-icon
                      :message="$t('punition.notVisibleToParents')"
                      :description="$t('punition.notVisibleToParentsHint')"
                    />
                    <div
                      v-else-if="Array.isArray(updateData.seenBy) && updateData.seenBy.length"
                      class="punishment-seen-list"
                    >
                      <div
                        v-for="(item, idx) in updateData.seenBy"
                        :key="`drawer-seen-${item.parent || idx}-${item.seenAt || idx}`"
                        class="punishment-seen-item"
                      >
                        <span>{{ formatSeenByParent(item) }}</span>
                        <span class="text-muted">{{ formatSeenByDate(item) }}</span>
                      </div>
                    </div>
                    <span v-else>{{ $t("punition.noParentSeen") }}</span>
                  </div>
                  <div class="col-md-12 mt-2 punishment-attachments-block">
                    <strong>Attachments:</strong>
                    <div
                      v-if="updateData.attachments && updateData.attachments.length"
                      class="punishment-attachments-grid"
                    >
                      <div
                        v-for="(file, index) in updateData.attachments"
                        :key="`att-${index}`"
                        class="punishment-attachment-item"
                      >
                        <img
                          v-if="isImageFile(file)"
                          :src="fileUrl(file)"
                          class="punishment-attachment-thumb"
                          role="button"
                          tabindex="0"
                          alt=""
                          @click.stop="openFullImage(fileUrl(file))"
                          @keydown.enter.prevent="openFullImage(fileUrl(file))"
                        />
                        <a
                          v-else
                          :href="fileUrl(file)"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="punishment-doc-tile"
                          :class="'punishment-doc-tile--' + attachmentDocKind(file)"
                        >
                          <a-icon :type="attachmentIconType(file)" class="punishment-doc-tile__icon" />
                          <span class="punishment-doc-tile__name" :title="cleanAttachmentName(file)">{{
                            shortAttachmentLabel(file)
                          }}</span>
                        </a>
                      </div>
                    </div>
                    <span v-else>--</span>
                  </div>
                  <div class="col-md-12 mt-2 punishment-audio-block">
                    <strong>Audio:</strong>
                    <div v-if="updateData.audios && updateData.audios.length">
                      <div v-for="(audio, index) in updateData.audios" :key="`audio-${index}`" class="mb-2">
                        <audio controls :src="fileUrl(audio)" style="width: 100%"></audio>
                      </div>
                    </div>
                    <span v-else>--</span>
                  </div>
                </div>
                <div class="row" v-if="updateData.rejectionReason">
                  <div class="col-md-12">
                    <strong class="pr-1">
                      {{ isKenyan ? $t("punition.rejectReasonDiscipline") : $t("punition.rejectReason") }}: </strong
                    >{{ updateData.rejectionReason }}
                  </div>
                </div>
              </fieldset>
              <div
                :style="{
                  position: 'absolute',
                  right: 0,
                  bottom: 0,
                  width: '100%',
                  borderTop: '1px solid #e9e9e9',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'right',
                  zIndex: 1,
                }"
              >
                <a-button-group style="width: 100%">
                  <a-button
                    style="width: 100%"
                    :disabled="updateData.validated === 'validated'"
                    type="primary"
                    @click.stop="validation(updateData._id, 'validated')"
                  >
                    <a-icon type="check" />{{ $t("punition.valider") }}
                  </a-button>
                  <a-button
                    style="width: 100%"
                    :disabled="updateData.validated === 'rejected'"
                    type="danger"
                    @click.stop="
                      () => {
                        visibleProfileData = false;
                        openReasonModal(updateData._id);
                      }
                    "
                  >
                    {{ $t("punition.rejeter") }}<a-icon type="right" />
                  </a-button>
                </a-button-group>
              </div>
            </a-form>
          </a-drawer>
        </div>
      </div>
      <div>
        <a-page-header :title="isKenyan ? $t('punition.studentDisciplineList') : $t('menu.listePunition')">
          <template slot="extra">
            <a-button type="primary" key="2" @click="showAddPunishment">
              <a-icon type="user-add" />{{ $t("all.add") }}
              {{ isKenyan ? $t("punition.studentDiscipline") : $t("punition.punition") }}
            </a-button>
          </template>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div>
              <span class="mr-2">{{
                $t("teacherGradePermissions.chooseTrimester")
              }}</span>
              <a-select
                style="width: 140px"
                v-model="selectedTrimester"
                @change="onTrimesterChange"
              >
                <a-select-option value="1"
                  >{{ $t("actualite.trimestre1") }}
                </a-select-option>
                <a-select-option value="2"
                  >{{ $t("actualite.trimestre2") }}
                </a-select-option>
                <a-select-option value="3"
                  >{{ $t("actualite.trimestre3") }}
                </a-select-option>
              </a-select>
            </div>
            <a-row type="flex">
              <a-statistic
                :title="$t('liste.total')"
                :value="punishmentStats.all"
              />
              <a-statistic
                :title="$t('punition.nonEvalues')"
                prefix="%"
                :value="
                  punishmentStats.all != 0
                    ? (
                        (punishmentStats.pending / punishmentStats.all) *
                        100
                      ).toFixed(2)
                    : 0
                "
                :style="{ margin: '0 32px' }"
              />
              <a-statistic
                :title="$t('punition.valides')"
                prefix="%"
                :value="
                  punishmentStats.all != 0
                    ? (
                        (punishmentStats.accepted / punishmentStats.all) *
                        100
                      ).toFixed(2)
                    : 0
                "
                :style="{ margin: '0 32px' }"
              />
              <a-statistic
                :title="$t('punition.rejetes')"
                prefix="%"
                :value="
                  punishmentStats.all != 0
                    ? (
                        (punishmentStats.rejected / punishmentStats.all) *
                        100
                      ).toFixed(2)
                    : 0
                "
              />
            </a-row>
          </div>
        </a-page-header>
        <div class="punishment-table-scroll">
          <a-table
            :pagination="pagination"
            :data-source="data"
            :loading="tableLoading"
            :columns="columns"
            :scroll="{ x: 'max-content' }"
            @change="handleTableChange"
            :customRow="
              (record) => {
                return {
                  on: {
                    click: () => {
                      profile(record);
                    },
                  },
                };
              }
            "
            rowKey="_id"
          >
          <template slot="name" slot-scope="text, record">
            <div
              key="firstName"
              @click.stop="() => openProfile(record.student._id)"
            >
              <a-avatar
                size="large"
                v-if="record.student.photo"
                :src="
                  settings.resourcesUrl.replace(
                    'FILE_PATH',
                    record.student.photo
                  )
                "
              />
              <a-avatar
                size="large"
                style="color: #f56a00; background-color: #fde3cf"
                v-else
              >
                {{ record.student.firstName[0].toUpperCase() }}
              </a-avatar>
              <a-button size="small" type="link" class="ml-2">
                {{  record.student.firstName + (record.student.middleName ? " " + record.student.middleName : "")+ " " +record.student.lastName  }}
              </a-button>
            </div>
          </template>
          <template slot="reason" slot-scope="text">
            <span v-if="text.length < 17">{{ text }}</span>
            <span v-else>{{ text.slice(0, 14) }} ...</span>
          </template>
          <template slot="createdby" slot-scope="text, record">
            <div class="d-flex">
              <div>{{ record.createdby.fullName }}</div>
              <div class="ml-auto">
                <a-tag :color="record.createdby.color">{{
                  $t(record.createdby.type)
                }}</a-tag>
              </div>
            </div>
          </template>
          <template slot="seenBy" slot-scope="seenBy, record">
            <a-tooltip
              v-if="record.validated !== 'validated'"
              :title="$t('punition.notVisibleToParentsHint')"
            >
              <a-tag color="orange" class="punishment-hidden-tag">
                <a-icon type="eye-invisible" />
                {{ $t("punition.notVisibleToParents") }}
              </a-tag>
            </a-tooltip>
            <a-button
              v-else
              type="link"
              @click.stop="openSeenByModal(record)"
              :disabled="!record.seenBy || record.seenBy.length === 0"
            >
              <a-icon
                type="eye"
                :style="{ color: record.seenBy && record.seenBy.length ? '#52c41a' : '#bfbfbf' }"
              />
              {{ record.seenBy ? record.seenBy.length : 0 }}
            </a-button>
          </template>

          <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations">
              <span v-if="record.editable">
                <a @click="() => save(record.key)">{{ $t("all.save") }}</a>
                <a-popconfirm
                  title="Sure to cancel?"
                  @confirm="() => cancel(record.key)"
                >
                  <a>{{ $t("action.annuler") }}</a>
                </a-popconfirm>
              </span>
              <span v-else>
                <a-button
                  type="primary"
                  :disabled="editingKey !== ''"
                  @click.stop="() => edit(record)"
                >
                  <a-icon
                    type="edit"
                    :disabled="editingKey !== ''"
                    @click.stop="() => edit(record)"
                  />{{ $t("action.modifier") }}
                </a-button>
              </span>
            </div>
          </template>
          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="$t('paiement.chercher') + ` ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
              >{{ $t("paiement.chercher") }}</a-button
            >
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
              >{{ $t("action.reinitialiser") }}</a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="customRender"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text }}</template>
          </template>
          <template slot="createdAt" slot-scope="text">
            {{ moment(text).format("DD/MM/YYYY HH:mm") }}
          </template>
          <template slot="time" slot-scope="text">
            {{ moment(text).format("DD/MM/YYYY HH:mm") }}
          </template>
          <template slot="reviewDate" slot-scope="text">
            <span v-if="text">
              {{ moment(text).format("DD/MM/YYYY HH:mm") }}
            </span>
            <span v-else>--</span>
          </template>
          <template slot="status" slot-scope="text">
            <a-tag color="green" v-if="text === 'validated'">
              {{ $t("punition.valides") }}
            </a-tag>
            <a-tag color="cyan" v-else-if="text === 'notValidated'">
              {{ $t("punition.nonEvalues") }}
            </a-tag>
            <a-tag color="red" v-else> {{ $t("punition.rejetes") }} </a-tag>
          </template>
          <template slot="validation" slot-scope="text, record">
            <a-button-group>
              <a-button
                :disabled="text === 'validated'"
                type="primary"
                @click.stop="validation(record._id, 'validated')"
              >
                <a-icon type="check" />{{ $t("punition.valider") }}
              </a-button>
              <a-button
                :disabled="text === 'rejected'"
                type="danger"
                @click.stop="openReasonModal(record._id)"
              >
                {{ $t("punition.rejeter") }}<a-icon type="right" />
              </a-button>
            </a-button-group>
          </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import "jspdf-autotable";
import { mapState } from "vuex";
import moment from "moment";
import router from "@/router";
import { isKenyanSchool } from "@/utilities/countrySpecific";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
import MagicUrl from "quill-magic-url";
import "quill/dist/quill.snow.css";
import { uploadFilesToS3 } from "@/services/uploadService";
const isTeacher = (teacher) => {
  return Array.isArray(teacher.role) && teacher.role.includes("teacher");
};
Quill.register("modules/magicUrl", MagicUrl);

export default {
  components: {
    quillEditor,
  },
  computed: {
    ...mapState(["user", "settings"]),
    isKenyan() {
      return isKenyanSchool();
    },
    requirePunishmentValidation() {
      const building = (this.user.building || []).find(
        (b) => b.dbName == this.settings.activeBuilding
      );
      return !!building?.config?.requirePunishmentValidation;
    },
    addPunitionConfirmMessage() {
      if (this.requirePunishmentValidation) {
        return this.isKenyan
          ? this.$t("punition.pendingValidationMessageDiscipline")
          : this.$t("punition.pendingValidationMessage");
      }
      return this.isKenyan
        ? this.$t("punition.autoValidationMessageDiscipline")
        : this.$t("punition.autoValidationMessage");
    },
  columns() {
    return [
        {
          title: this.$t("liste.nomPrenom"),
          dataIndex: "firstName",
          key: "firstName",
          width: 250,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "name",
          },
          onFilter: (value, record) =>
            record.student.firstName
              .toLowerCase()
              .includes(value.toLowerCase()) ||
            (record.student.middleName && record.student.middleName.toLowerCase().includes(value.toLowerCase())) ||
            record.student.lastName.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.type"),
          dataIndex: "punishmentType.name",
          key: "punishmentType",

          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "punishmentType.name",
          },
          onFilter: (value, record) =>
            record.punishmentType.name
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("topBar.status"),
          dataIndex: "validated",
          key: "status",

          scopedSlots: {
            customRender: "status",
          },
          filters: [
            {
              text: this.$t("punition.valides"),
              value: "validated",
            },
            {
              text: this.$t("punition.rejetes"),
              value: "rejected",
            },
            {
              text: this.$t("punition.nonEvalues"),
              value: "notValidated",
            },
          ],
          onFilter: (value, record) => record.validated.indexOf(value) === 0,
        },
        {
          title: this.$t("punition.dateAjout"),
          dataIndex: "createdAt",
          key: "createdAt",
          sorter: true,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "createdAt",
          },
          onFilter: (value, record) =>
            record.createdAt && record.createdAt.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("punition.eventTime"),
          dataIndex: "time",
          key: "time",
          sorter: true,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "time",
          },
          onFilter: (value, record) =>
            record.time && record.time.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("punition.dateEvalution"),
          dataIndex: "reviewDate",
          key: "reviewDate",

          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "reviewDate",
          },
          onFilter: (value, record) =>
            record.reviewDate.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("punition.raison"),
          dataIndex: "reason",
          key: "reason",
          width: 120,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "reason",
          },
          onFilter: (value, record) =>
            record.reason.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("punition.createdBy"),
          dataIndex: "createdby",
          key: "createdby",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "createdby",
          },
          onFilter: (value, record) =>
            record.createdby.fullName
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("punition.seenByParents"),
          dataIndex: "seenBy",
          key: "seenBy",
          scopedSlots: {
            customRender: "seenBy",
          },
          width: 160,
        },
        {
          title: this.$t("punition.validation"),
          dataIndex: "validated",
          scopedSlots: { customRender: "validation" },
          fixed: "right",
        },
      ];
    },
  },
  async created() {
    await this.findPunishment(1, this.pagination.pageSize);
    apiClient
      .post("/classrooms/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            name: 1,
          },
        },
      })
      .then((res) => (this.classList = res.data))
      .catch((e) => this.$message.error("Aucunne classe est trouvé"));
    apiClient
      .post("/punishmentType/filter", {
        query: {},
      })
      .then((res) => (this.punishmentTypes = res.data))
      .catch((e) =>
        this.$message.error(
          this.isKenyan
            ? this.$t("punition.noDisciplineTypeFound")
            : this.$t("punition.noPunishmentTypeFound")
        )
      );
    this.cacheData = this.data.map((item) => ({ ...item }));
  },
  data() {
    return {
      classRoomChangeLoading: false,
      studentList: [],
      classList: [],
      selectedStudents: [],
      punishmentTypes: [],
      punishmentStats: {
        all: 0,
        pending: 0,
        accepted: 0,
        rejected: 0,
      },
      positionsList: [],
      subjectsList: [],
      dateFormat: "DD/MM/YYYY",
      editingKey: "",
      tableLoading: false,
      visibleParentFile: false,
      visibleSeenByModal: false,
      selectedSeenBy: [],
      selectedPunishment: null,
      visibleModal: false,
      data: [],
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      targetKeys: [],
      previewVisible: false,
      previewImage: "",
      form: this.$form.createForm(this),
      updateForm: this.$form.createForm(this),
      rejectForm: this.$form.createForm(this),
      punishmentForm: this.$form.createForm(this),
      updateData: {
        student: {
          firstName: "",
          lastName: "",
        },
        punishmentType: {
          _id: "",
          name: "",
        },
        reason: "",
        desc: "",
        desc: "",
        _id: "",
      },
      selectedTrimester: "1",
      value: 1,
      value1: 1,
      loadingEnseignant: false,
      visibleData: false,
      visibleUpdateData: false,
      visibleProfileData: false,
      addPunishmentModal: false,
      addPunishmentLoading: false,
      isUploadingFiles: false,
      progress: { value: 0 },
      punishmentDescription: "",
      attachmentFiles: [],
      audioFiles: [],
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            ["link"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
          ],
          magicUrl: true,
        },
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      sortBy: "createdAt",
      sortOrder: "desc",
    };
  },
  methods: {
    async findPunishment(page = 1, pageSize = 10, sortBy = null, sortOrder = null) {
      this.tableLoading = true;
      const params = {
        page: page,
        limit: pageSize,
      };

      if (this.selectedTrimester) {
        params.trimester = this.selectedTrimester;
      }

      // Use provided sort parameters or fall back to current state
      params.sortBy = sortBy !== null ? sortBy : this.sortBy;
      params.sortOrder = sortOrder !== null ? sortOrder : this.sortOrder;

      // Update state to keep it in sync
      if (sortBy !== null) this.sortBy = sortBy;
      if (sortOrder !== null) this.sortOrder = sortOrder;

      await apiClient
        .get("/studentPunishment", { params })
        .then((res) => {
          this.pagination.current = res.data.pagination.currentPage;
          this.pagination.pageSize = res.data.pagination.pageSize;
          this.pagination.total = res.data.pagination.total;

          this.punishmentStats = res.data.stats || {
            all: 0,
            pending: 0,
            accepted: 0,
            rejected: 0,
          };

          // Process data
          this.data = res.data.data.map((elem) => {
            elem.key = elem._id;
            const teacher = elem.teacher?.employee;
            elem.createdby = {
              fullName: elem.admin
                ? elem.admin.fullName + " " + elem.admin.userName
                : teacher
                ? teacher.firstName + " " + teacher.lastName
                : "--",
              color: elem.admin
                ? "purple"
                : isTeacher(elem.teacher)
                ? "blue"
                : "orange",
              type: elem.admin ? "autorisation.admin" : "emploi.enseignant",
            };
            return elem;
          });
        })
        .catch((error) => {
          this.$message.error(
            this.isKenyan
              ? this.$t("punition.errorLoadingDisciplines")
              : this.$t("punition.errorLoadingPunishments")
          );
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      // Handle sorting
      if (sorter && sorter.field) {
        this.sortBy = sorter.field;
        this.sortOrder = sorter.order === "ascend" ? "asc" : "desc";
      }

      this.findPunishment(
        pagination.current,
        pagination.pageSize,
        this.sortBy,
        this.sortOrder
      );
    },
    onTrimesterChange() {
      // Reset to first page when trimester changes
      this.pagination.current = 1;
      this.findPunishment(1, this.pagination.pageSize);
    },
    moment,
    resetAndCloseAddPunishment() {
      this.punishmentForm.resetFields();
      this.studentList = [];
      this.selectedStudents = [];
      this.punishmentDescription = "";
      this.attachmentFiles = [];
      this.audioFiles = [];
      this.classRoomChangeLoading = false;
      this.addPunishmentModal = false;
      this.addPunishmentLoading = false;
    },
    currentUploadSizeMB(extra = 0) {
      const attachmentsSize = this.attachmentFiles.reduce(
        (sum, file) => sum + (file.size || file.originFileObj?.size || 0),
        0
      );
      const audiosSize = this.audioFiles.reduce(
        (sum, file) => sum + (file.size || file.originFileObj?.size || 0),
        0
      );
      return (attachmentsSize + audiosSize + extra) / 1024 / 1024;
    },
    beforeUploadAttachment(file) {
      const mime = (file.type || "").toLowerCase();
      if (mime.startsWith("video/") || mime.startsWith("audio/")) {
        this.$message.error(this.$t("error.onlyImagesPDFWordExcel"));
        return false;
      }
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      const extension = (file.name || "").split(".").pop()?.toLowerCase();
      const allowedExtensions = [
        "jpg",
        "jpeg",
        "png",
        "webp",
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
      ];
      if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(extension || "")) {
        this.$message.error(this.$t("error.onlyImagesPDFWordExcel"));
        return false;
      }
      if (this.currentUploadSizeMB(file.size || 0) > 50) {
        this.$message.error(this.$t("error.image50"));
        return false;
      }
      this.attachmentFiles = [...this.attachmentFiles, file];
      return false;
    },
    beforeUploadAudio(file) {
      const mime = (file.type || "").toLowerCase();
      if (mime.startsWith("video/")) {
        this.$message.error(this.$t("error.onlyAudioFilesAllowed"));
        return false;
      }
      const allowedTypes = [
        "audio/mpeg",
        "audio/mp3",
        "audio/wav",
        "audio/x-wav",
        "audio/ogg",
        "audio/webm",
        "audio/x-m4a",
        "audio/mp4",
        "audio/aac",
        "audio/flac",
        "audio/x-flac",
      ];
      const extension = (file.name || "").split(".").pop()?.toLowerCase();
      const allowedExtensions = ["mp3", "wav", "ogg", "webm", "m4a", "aac", "flac"];
      if (!allowedExtensions.includes(extension || "")) {
        this.$message.error(this.$t("error.onlyAudioFilesAllowed"));
        return false;
      }
      if (extension === "webm" && mime && mime !== "audio/webm") {
        this.$message.error(this.$t("error.onlyAudioFilesAllowed"));
        return false;
      }
      const okMime =
        allowedTypes.includes(file.type) ||
        !mime ||
        mime === "application/octet-stream" ||
        (mime.startsWith("audio/") && allowedExtensions.includes(extension || ""));
      if (!okMime) {
        this.$message.error(this.$t("error.onlyAudioFilesAllowed"));
        return false;
      }
      if (this.currentUploadSizeMB(file.size || 0) > 50) {
        this.$message.error(this.$t("error.image50"));
        return false;
      }
      this.audioFiles = [...this.audioFiles, file];
      return false;
    },
    removeAttachmentFile(file) {
      this.attachmentFiles = this.attachmentFiles.filter((f) => f.uid !== file.uid);
    },
    removeAudioFile(file) {
      this.audioFiles = this.audioFiles.filter((f) => f.uid !== file.uid);
    },
    fileUrl(path) {
      return this.settings.resourcesUrl.replace("FILE_PATH", path);
    },
    extractFileName(path) {
      return path?.split("/").pop() || path;
    },
    cleanAttachmentName(path) {
      const full = this.extractFileName(path) || "";
      const sep = full.indexOf("--");
      return sep !== -1 ? full.substring(sep + 2) : full;
    },
    shortAttachmentLabel(path) {
      const clean = this.cleanAttachmentName(path);
      return clean.length > 32 ? clean.slice(0, 29) + "…" : clean;
    },
    getFileExtension(path) {
      const name = this.extractFileName(path) || "";
      const base = name.includes("--") ? name.substring(name.indexOf("--") + 2) : name;
      const parts = base.toLowerCase().split(".");
      return parts.length > 1 ? parts.pop() : "";
    },
    isImageFile(path) {
      return ["jpg", "jpeg", "png", "gif", "webp"].includes(this.getFileExtension(path));
    },
    isPdfFile(path) {
      return this.getFileExtension(path) === "pdf";
    },
    isWordFile(path) {
      return ["doc", "docx"].includes(this.getFileExtension(path));
    },
    attachmentDocKind(path) {
      if (this.isPdfFile(path)) return "pdf";
      if (this.isWordFile(path)) return "word";
      return "other";
    },
    attachmentIconType(path) {
      if (this.isPdfFile(path)) return "file-pdf";
      if (this.isWordFile(path)) return "file-text";
      return "file";
    },
    openFullImage(url) {
      if (!url) return;
      this.previewImage = url;
      this.previewVisible = true;
    },
    closeImagePreview() {
      this.previewVisible = false;
      this.previewImage = "";
    },
    handleChangeClass(selectedClassRoom) {
      this.classRoomChangeLoading = true;
      this.selectedStudents = [];
      let match = {};
      match[`schoolarYearsHistory.${this.settings.activeSchoolarYear}`] =
        selectedClassRoom;
      apiClient
        .post("/students/filter", {
          query: {
            status: "active",
          },
          aggregation: [
            {
              $match: match,
            },
            {
              $set: {
                classRoom: {
                  $convert: {
                    input: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
                    to: "objectId",
                    onError: null,
                    onNull: null,
                  },
                },
              },
            },
            {
              $set: {
                classRoomName: "$classRoom",
              },
            },
            {
              $lookup: {
                from: "classrooms",
                localField: "classRoom",
                foreignField: "_id",
                as: "classRoomName",
              },
            },
            {
              $project: {
                _id: 1,
                firstName: 1,
                middleName: 1,
                lastName: 1,
              },
            },
          ],
        })
        .then((res) => {
          const { data } = res;
          this.studentList = data;
          this.classRoomChangeLoading = false;
        })
        .catch((e) => this.$message.error(this.$t("error.aucEleve")));
    },
    selectStudents(students) {
      this.selectedStudents = students;
    },
    showAddPunishment() {
      this.addPunishmentModal = true;
    },
    openProfile(id) {
      router.push(`/eleve/${id}`);
    },
    profile(record) {
      this.updateData = record;
      this.visibleProfileData = true;
    },
    openSeenByModal(record) {
      this.selectedSeenBy = Array.isArray(record.seenBy) ? record.seenBy : [];
      this.visibleSeenByModal = true;
    },
    formatSeenByParent(item) {
      return item?.parentName || "Parent";
    },
    formatSeenByDate(item) {
      const seenDate = item?.seenAt || item?.createdAt || item?.updatedAt;
      return seenDate ? moment(seenDate).format("DD/MM/YYYY HH:mm") : "--";
    },
    closeSeenByModal() {
      this.visibleSeenByModal = false;
      this.selectedSeenBy = [];
    },
    handleCancel(e = null) {
      this.form.resetFields();
      this.updateForm.resetFields();
      this.rejectForm.resetFields();
      this.visibleData = false;
      this.visibleUpdateData = false;
      this.visibleProfileData = false;
    },
    handleConfirmAddPunition() {
      this.addPunition();
    },
    addPunition(e) {
      if (e) {
        e.preventDefault();
      }
      this.punishmentForm.validateFields((err, values) => {
        if (!err) {
          this.addPunishmentLoading = true;
          if (this.punishmentDescription) {
            values.desc = this.punishmentDescription;
          } else {
            delete values.desc;
          }
          // Ensure trimester defaults to the currently selected trimester and is numeric
          values.trimester = Number(
            values.trimester !== undefined && values.trimester !== null
              ? values.trimester
              : this.selectedTrimester
          );
          const uploadAttachmentFiles = this.attachmentFiles.map(
            (file) => file.originFileObj || file
          );
          const uploadAudioFiles = this.audioFiles.map(
            (file) => file.originFileObj || file
          );
          const hasFilesToUpload =
            uploadAttachmentFiles.length > 0 || uploadAudioFiles.length > 0;
          this.isUploadingFiles = hasFilesToUpload;
          this.progress.value = 0;

          Promise.all([
            uploadAttachmentFiles.length
              ? uploadFilesToS3(
                  uploadAttachmentFiles,
                  "manager/punishment/attachments",
                  this.progress
                )
              : Promise.resolve([]),
            uploadAudioFiles.length
              ? uploadFilesToS3(
                  uploadAudioFiles,
                  "manager/punishment/audios",
                  this.progress
                )
              : Promise.resolve([]),
          ])
            .then(([attachments, audios]) => {
              this.isUploadingFiles = false;
              this.progress.value = 0;
              values.attachments = attachments;
              values.audios = audios;
              return apiClient.put("/studentPunishment/admin", {
                ...values,
                students: this.selectedStudents,
              });
            })
            .then(async () => {
              this.pagination.current = 1;
              await this.findPunishment(1, this.pagination.pageSize);
            })
            .catch((e) =>
              this.$notification.error({
                message: this.$t("error.error"),
              })
            )
            .finally(() => {
              this.isUploadingFiles = false;
              this.progress.value = 0;
              this.addPunishmentLoading = false;
              this.resetAndCloseAddPunishment();
            });
        }
      });
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    showModal() {
      this.visibleData = true;
    },
    onChange(e) {},
    onChangeParent(e) {},
    openReasonModal(id) {
      this.selectedPunishment = id;
      this.visibleModal = true;
    },
    cancelReject() {
      this.rejectForm.resetFields();
      this.visibleModal = false;
    },
    rejectPunition(e) {
      e.preventDefault();
      this.rejectForm.validateFields((err, values) => {
        if (!err)
          this.validation(this.selectedPunishment, "rejected", values.reason);
      });
    },
    validation(id, value, reason = "") {
      console.info("here: ", value);
      let date = moment();
      apiClient
        .patch("/studentPunishment/" + id, {
          validated: value,
          reviewDate: date,
          rejectionReason: reason,
        })
        .then(() => {
          this.$message.success(
            this.isKenyan
              ? this.$t("success.disciplineValid")
              : this.$t("success.punitionValid")
          );
          // Refresh the current page to get updated data
          this.findPunishment(this.pagination.current, this.pagination.pageSize);
        })
        .catch(() => {})
        .finally(() => {
          this.cancelReject();
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.editable-row-operations a {
  margin-right: 8px;
}

.switch {
  float: right;
  margin-right: 15px;
}

.bottom {
  margin-top: 7px;
}

label {
  width: 300px;
  line-height: 26px;
  margin-bottom: 20px;
}

a-input {
  height: 25px;
  width: 50%;
  margin-left: 50px;
}

.span {
  /* display: flex;  */
  flex-direction: row;
}

.space {
  margin-left: 200px;
}

.inp {
  margin-left: 0px;
}

.clearfix {
  float: right;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.card >>> .ant-table-tbody tr {
  cursor: pointer !important;
}

.punishment-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.punishment-seen-list {
  margin-top: 6px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}

.punishment-seen-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.punishment-seen-item:last-child {
  border-bottom: none;
}

.punishment-hidden-tag {
  margin: 0;
  white-space: normal;
  font-weight: 500;
}

.punishment-profile-drawer-body {
  padding-bottom: 96px;
}

.punishment-attachments-block,
.punishment-audio-block {
  margin-bottom: 1.25rem;
}

.punishment-attachment-thumb {
  max-width: 180px;
  max-height: 120px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #e8e8e8;
  display: block;
}

.punishment-attachment-thumb:hover {
  opacity: 0.92;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.punishment-attachments-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
}

.punishment-attachment-item {
  flex: 0 0 auto;
}

.punishment-doc-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  min-height: 120px;
  padding: 10px 8px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background: #fafafa;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.85);
  transition: box-shadow 0.2s, border-color 0.2s;
}

.punishment-doc-tile:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
  color: rgba(0, 0, 0, 0.85);
}

.punishment-doc-tile__icon {
  font-size: 48px;
  line-height: 1;
  margin-bottom: 8px;
}

.punishment-doc-tile--pdf .punishment-doc-tile__icon {
  color: #e74c3c;
}

.punishment-doc-tile--word .punishment-doc-tile__icon {
  color: #2b579a;
}

.punishment-doc-tile--other .punishment-doc-tile__icon {
  color: #8c8c8c;
}

.punishment-doc-tile__name {
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
  word-break: break-word;
  max-width: 100%;
}

.punishment-preview-img {
  width: 100%;
  max-height: 82vh;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}
</style>
